module.exports = __webpack_public_path__ + "img/chivas-crytal-bottle-mobile.a6290774.png";